import PropTypes from 'prop-types';

export default function loader(Loader) {
  return Component => {
    const CustomLoaderProvider = props => <Component {...props} customLoader={props.customLoader || Loader} />;

    CustomLoaderProvider.propTypes = { customLoader: PropTypes.func };

    return CustomLoaderProvider;
  };
}
